import React, { useEffect, useState } from 'react';

import { useMsal } from '@azure/msal-react';
import { useAccount } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';

import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';

import config from '../../config';

function ADB2CLogin(props) 
{
  const [loading, setLoading] = useState(true);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts?.[0] || {} );
  const isAuthenticated = useIsAuthenticated();
  const [callbackCalled, setCallbackCalled] = useState(false);
  
  useEffect(() => {
    if(isAuthenticated && !callbackCalled){
      setLoading(true);
      setCallbackCalled(true);
      callback(account);
    }
    else if(!isAuthenticated) {
      setLoading(false);
    }
  });

  const callback = async (account) => {
    const result = await instance.acquireTokenSilent({
      scopes: [],
      account: account
    });
    const payload = { status: "authenticated", accountId: account.idTokenClaims.email || account.username || account.idTokenClaims.UPN || account.idTokenClaims.signinname, name: account.idTokenClaims.given_name + " " + account.idTokenClaims.family_name, token: result.idToken };
    
    props.onCallback(payload)
  }

  const LoginHandler = () =>{
    try {
      //setLoading(true);
      instance.loginRedirect();
    } catch (err) {
      //setLoading(false);
      console.log(err);
    }
  }

  const LogoutHandler = () => {
    try {
      console.log("Trying to logout")
      const logoutResponse = instance.logout();
      console.log(logoutResponse)
    } catch (err) {
    console.log(err)
  }
}

  if(props.client.config.custom_initial_page && props.client.config.custom_initial_page.url && props.client.config.custom_initial_page.url !== ""){
    return <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
      }}>
        { loading && <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                <ProgressSpinner strokeWidth="5"/>
            </div> }
        { !loading && <>
          <div 
            style={{
              backgroundColor: props.client.custom_layout.primaryBackgroundColor || '',
              display: 'flex',
              height: '100px',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '30px'
            }}>
            <div><img alt="Logo" src={props.client.logo} style={{maxHeight: '40px'}} /></div>
            { (config.label || "") !== "" && <div>{config.label}</div> }
            <div>
              <Button 
                label={isAuthenticated ? "Sair" : "Entrar"}
                onClick={isAuthenticated? LogoutHandler : LoginHandler}
                style={{backgroundColor: props.client.custom_layout.primaryButtonColor || '', borderColor: props.client.custom_layout.primaryButtonColor || ''}}
              />
            </div>
          </div>
          <div
            style={{
              flex: 1,
              backgroundColor: props.client.custom_layout.secondaryBackgroundColor
            }}
          >
            <iframe src={props.client.config.custom_initial_page.url} width="100%" height="100%" frameBorder="0"/>
          </div>
        </>}
    </div>
  }

  return (
    <>
      <div style={{width: '100%', height: '100%', margin: 'auto',display:'flex', alignItems:'center', justifyContent: 'center', backgroundColor: props.client.custom_layout.secondaryBackgroundColor || ''}}>
          <Panel style={{width: '400px', margin: 'auto', backgroundColor: props.client.custom_layout.primaryBackgroundColor || ''}}>
              <div className="p-grid" style={{backgroundColor: props.client.custom_layout.primaryBackgroundColor || ''}}>
                  <div className="p-col-12" style={{textAlign: 'center', marginTop:'20px'}}><img alt="Logo" src={props.client.logo} style={{maxWidth: '300px'}} /></div>
                 
                  { loading && <div className="p-col-12" style={{textAlign: 'center'}}><ProgressBar mode="indeterminate"/></div> }
                  <div className="p-col-12" style={{textAlign: 'center'}}>{config.label}</div>
                  { !loading && 
                    <>
                     <div className="p-col-12" style={{textAlign: 'center'}}>
                      <Button 
                        label={isAuthenticated ? "Sair" : "Entrar"}
                        onClick={isAuthenticated? LogoutHandler : LoginHandler}
                        style={{backgroundColor: props.client.custom_layout.primaryButtonColor || '', borderColor: props.client.custom_layout.primaryButtonColor || ''}}
                      />
                      </div>
                    </>
                  }
                  
              </div>
              
          </Panel>
          
      </div>
           
    </>    
  );
}

export default ADB2CLogin;
